<template>
  <div class="mainClass">
    <!-- Buttons to trigger modals -->
    <div class="buttonGroup">
      <button type="button" class="btn btn-primary mb-2" data-bs-toggle="modal" data-bs-target="#registrationModal">
        Register Institute
      </button>
      <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addLocationModal">
        Add Location
      </button>
    </div>

    <!-- Institute Registration Modal -->
    <div class="modal fade" id="registrationModal" tabindex="-1" aria-labelledby="registrationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="registrationModalLabel">Institute Registration</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- <InsertInstitute /> -->
            <!-- Listen for the 'instituteAdded' event -->
            <InsertInstitute @instituteAdded="fetchInstitutes" />
          </div>
        </div>
      </div>
    </div>

    <!-- Add Location Modal -->
    <div class="modal fade" id="addLocationModal" tabindex="-1" aria-labelledby="addLocationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="addLocationModalLabel">Add Location</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <InsertLocation />
          </div>
        </div>
      </div>
    </div>

    <!-- Institute Table -->
    <div class="container mt-4">
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark">
            <tr>
              <th>ID</th>
              <th>Institute Name</th>
              <th>Address</th>
              <th>Contact</th>
              <th>Location</th>
              <th>First Name</th>
              <th>Email</th>
              <th>View</th>
              <th>More</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="institute in institutes" :key="institute.id">
              <td>{{ institute.id }}</td>
              <td>{{ institute.institute_name }}</td>
              <td>{{ institute.address }}</td>
              <td>{{ institute.contact }}</td>
              <td>{{ institute.location_id }}</td>
              <td>{{ institute.user ? institute.user.first_name : 'N/A' }}</td>
              <td>{{ institute.user ? institute.user.email : 'N/A' }}</td>
              <td>
                <button @click="viewInstituteDetails(institute.id)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#showInstituteModal">
                  <i class="bi bi-eye"></i> View
                </button>
              </td>
              <td>
                <button @click="moreInstituteDetails(institute.id)" class="btn btn-outline-primary btn-sm">
                  <i class="bi bi-three-dots"></i> More
                </button>
              </td>
              <td>
                <button @click="editInstituteDetails(institute.id)" class="btn btn-outline-warning btn-sm" data-bs-toggle="modal" data-bs-target="#editInstituteModal">
                  <i class="bi bi-pencil"></i> Edit
                </button>
              </td>
              <td>
                <button @click="deleteInstitute(institute.id)" class="btn btn-outline-danger btn-sm">
                  <i class="bi bi-trash"></i> Delete
                </button>
              </td>
            </tr>
          </tbody>

        </table>

        <div class="d-flex justify-content-between align-items-center mt-3">
  <div>Total Institutes: {{ totalInstitutes }}</div>
  <nav>
    <ul class="pagination">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <button class="page-link" @click="fetchInstitutes(currentPage - 1)">Previous</button>
      </li>
      <li
        class="page-item"
        v-for="page in lastPage"
        :key="page"
        :class="{ active: page === currentPage }"
      >
        <button class="page-link" @click="fetchInstitutes(page)">{{ page }}</button>
      </li>
      <li class="page-item" :class="{ disabled: currentPage === lastPage }">
        <button class="page-link" @click="fetchInstitutes(currentPage + 1)">Next</button>
      </li>
    </ul>
  </nav>
</div>



        <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- No Data Found Message -->
    <div v-else-if="institutes.length === 0" class="text-center my-4">
      <p class="text-muted fs-5">No data found</p>
    </div>
      </div>
    </div>

    <!-- Modal View -->
    <div class="modal fade" id="showInstituteModal" tabindex="-1" aria-labelledby="showInstituteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="showInstituteModalLabel">Institute Details</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <ViewInstitute :institute="selectedInstitute" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" id="editInstituteModal" tabindex="-1" aria-labelledby="editInstituteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="editInstituteModalLabel">Edit Institute</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <EditInstitute :institute="selectedInstituteEdit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InsertInstitute from '@/components/Institute/InsertInstitute.vue';
import InsertLocation from '@/components/Institute/InsertLocation.vue';
import EditInstitute from '@/components/Institute/EditInstitute.vue';
import ViewInstitute from '@/components/Institute/ViewInstitute.vue';
import axios from 'axios';

export default {
  name: 'InstituteTable',
  components: {
    InsertInstitute,
    InsertLocation,
    EditInstitute,
    ViewInstitute,
  },
  data() {
    return {
      loading: true, // Initial state
      institutes: [],
      selectedInstitute: null, // Store the selected institute details here
      selectedInstituteEdit: null,
      currentPage: 1,
    lastPage: 1,
    totalInstitutes: 0,
    };
  },
  mounted() {
    this.fetchInstitutes();
  },
  methods: {
    // async fetchInstitutes() {
    //   try {
    //     this.loading = true;
    //     const response = await axios.get('/get-institutes');
    //     this.institutes = response.data;
    //   } catch (error) {
    //     console.error('Error fetching institutes:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async fetchInstitutes(page = 1) {
  try {
    this.loading = true;
    const response = await axios.get(`/get-institutes?page=${page}`);
    this.institutes = response.data.data;
    this.currentPage = response.data.current_page;
    this.lastPage = response.data.last_page;
    this.totalInstitutes = response.data.total;
  } catch (error) {
    console.error('Error fetching institutes:', error);
  } finally {
    this.loading = false;
  }
},

    async deleteInstitute(id) {
      try {
        await axios.delete(`/delete-institute/${id}`);
        this.institutes = this.institutes.filter(institute => institute.id !== id);
        alert('Institute deleted successfully');
      } catch (error) {
        console.error('Error deleting institute:', error);
        alert('Failed to delete institute');
      }
    },

    async viewInstituteDetails(id) {
      try {
        const response = await axios.get(`/get-institute-by-id/${id}`);
        this.selectedInstitute = response.data;
      } catch (error) {
        console.error('Error fetching institute details:', error);
        this.selectedInstitute = null;
      }
    },

    async editInstituteDetails(id) {
      try {
        const response = await axios.get(`/get-institute-by-id/${id}`);
        this.selectedInstituteEdit = response.data;
      } catch (error) {
        console.error('Error fetching institute details for edit:', error);
        this.selectedInstituteEdit = null;
      }
    },

    moreInstituteDetails(id) {
  // Navigate to the more details page using query parameters
  this.$router.push({ name: 'MoreInstituteDetails', query: { instituteId: id } });
},
  },
};
</script>

<style scoped>
.mainClass {
  width: 100%;
  height: 100%;
}
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.buttonGroup {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
}
.table-responsive {
  max-width: 100%;
  overflow-x: auto;
}
@media (max-width: 768px) {
  .modal-dialog-centered {
    max-width: 100%;
    margin: 0;
  }
  .buttonGroup {
    width: 100%;
    height: 100%;
    display: inline-block;
    align-items: center;
    justify-content: center;
    padding: 10px 50px;
  }
  .btn {
    width: 100%;
    margin-bottom: 5px;
  }
  .modal-content {
    padding: 10px;
  }
  .table-responsive {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-x: scroll;
    max-width: 75svw;
  }
}
</style>
